import styled from 'styled-components';
import { colors } from '../colors';

interface formLabelProps {
	width?: string;
}
const ErrorMsg = styled.div<formLabelProps>`
	width: 100%;
	margin-top: 8px;
	font-size: 13px;
	color: ${colors.Red};
	width: ${({ width }) => width}!important;
`;

export default ErrorMsg;
